import { render, staticRenderFns } from "./IconNeedUpgradePlan.vue?vue&type=template&id=c770a07c&scoped=true&"
import script from "./IconNeedUpgradePlan.vue?vue&type=script&lang=js&"
export * from "./IconNeedUpgradePlan.vue?vue&type=script&lang=js&"
import style0 from "./IconNeedUpgradePlan.vue?vue&type=style&index=0&id=c770a07c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c770a07c",
  null
  
)

export default component.exports